/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/action-list';
 */
export const layoutConfig = {
    styles: {
        borderlessSearch: false,
    },
    dimensions: {
        maxHeight: 260,
    },
    columnWidth: {
        actionId: 90,
        actionDate: 60,
        actionTime: 60,
        members: 150,
        memberId: 130,
        representative: 130,
    },
    filterFlyoutWidths: {
        members: 180,
        memberId: 180,
        representative: 180,
    },
    valueColors: {
        resolution: {
            resolved: '#59ad00',
            unresolved: '#e7aa00',
        },
    },
    actionIcons: {},
};
